import styled from '@emotion/styled';
import { css } from "@emotion/react";

export interface InputProps {
    error: boolean
}

const normalInputState = css`
    border-color: #e16b6b;
    color: #5a1f1f;
    caret-color: #d44b4b;

    &::placeholder {
        color: #d26b6b;
    }
`;

const erroredInputState = css`
    color: #2f2410;
    border-color: rgba(255, 212, 11, 0.65);
    caret-color: #a67c00;
`;

export const Input = styled.input<InputProps>`
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
    user-select: none;
    border-radius: 12px;
    border-width: 1.5px;
    border-style: solid;
    background-color: #ffffff;
    text-align: start;
    transition: all 180ms cubic-bezier(0.4, 0, 0.2, 1);
    font-family: "EBENYA", sans-serif;
    letter-spacing: 1.5px;
    box-shadow: 0 8px 24px rgba(255, 212, 11, 0.16), inset 0 1px 0 rgba(0, 0, 0, 0.02);

    &:focus {
        transition: .25s all ease;
        outline: none;
        ${(props) => !props.error && css`
            border-color: #ffd40b;
            box-shadow: 0 12px 32px rgba(255, 212, 11, 0.28);
        `}
    }

    &::placeholder {
        color: rgba(88, 70, 20, 0.6);
        margin: 10px;
        font-size: 24px;
        font-weight: 300;
    }

    &:disabled {
        pointer-events: none;
        border-style: none;
    }

    &:not(:placeholder-shown) + label, &:focus + label {
        top: 0;
        left: 0.625rem;
        transform: translateY(-50%);
        border-radius: 0.25rem;
        background-color: #fff8e5;
        line-height: 1vh;
        color: #2f2410;
    }

    padding: 15px;
    font-size: 24px;
    ${(props) => props.error ? normalInputState : erroredInputState}
`;